export default "__VITE_ASSET__BzM7z5c3__";